import { Entitlements, User } from '@griply/types';

export const getUserHasPremium = (user: User | null | undefined) =>
  !!user?.entitlements?.includes(Entitlements.Premium);
